import { styled } from '@mui/material/styles';
import { Box } from '@sunwisesoftware/sunwise-ui';

export default styled(Box)(
    () =>
        `
            background-color: #000;
            bottom: 0;
            height: 100%;
            left: 0;
            position: relative;
            right: 0;
            top: 0;
            z-index: 1;

            .popup-container {
                cursor: pointer;
                height: 0;
                position: absolute;
                width: 200px;
                transform-origin: 0% 0%;
                z-index: 1;
                &:hover {
                    z-index: 2;
                }
                .popup-bubble-anchor {
                    position: absolute;
                    width: 100%;
                    bottom: 6px;
                    left: 0;
                    span {
                        position: absolute;
                        height: 13px;
                        top: 0;
                        left: 0;
                        transform: translate(-50%, -100%);
                        background-color: #0f4669;
                        color: #ffffff;
                        padding: 0 2px;
                        border-radius: 2px;
                        overflow-y: hidden;
                        max-height: 60px;
                        font-size: 8px;
                        letter-spacing: 0.2px;
                        line-height: 13px;
                        user-select: none;
                        font-weight: 100;
                    }
                }
            }
        `,
);
